import { render, staticRenderFns } from "./GuildLogs.vue?vue&type=template&id=2cf4e5d4&scoped=true&"
import script from "./GuildLogs.vue?vue&type=script&lang=js&"
export * from "./GuildLogs.vue?vue&type=script&lang=js&"
import style0 from "./GuildLogs.vue?vue&type=style&index=0&id=2cf4e5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4e5d4",
  null
  
)

export default component.exports